import React from 'react';
import { VideoScreenContent, VideoTreeWrapper } from '../screen';

const VideoPlayback = () => {
  return <VideoTreeWrapper Content={VideoScreenContent} isPlayback></VideoTreeWrapper>;
};
export default VideoPlayback;
